import { getCore as get, postCore as post, delCore as del, putCore as put } from "../../utils/httpInterceptor";

class TenantDataAreaService {
  // Store tenantId for instance methods
  constructor(tenantId = null) {
    this.tenantId = tenantId;
  }

  // Static methods with explicit tenantId
  static async list(tenantId) {
    return await get(`/api/tenants/${tenantId}/dataareas`);
  }

  static async add(tenantId, payload) {
    return await post(`/api/tenants/${tenantId}/dataareas`, payload);
  }

  static async update(tenantId, dataAreaId, payload) {
    return await put(`/api/tenants/${tenantId}/dataareas/${encodeURIComponent(dataAreaId)}`, payload);
  }

  static async getBranding(tenantId, dataAreaId) {
    return await get(`/api/tenants/${tenantId}/dataareas/${encodeURIComponent(dataAreaId)}/branding`);
  }

  static async updateBranding(tenantId, dataAreaId, payload) {
    return await put(`/api/tenants/${tenantId}/dataareas/${encodeURIComponent(dataAreaId)}/branding`, payload);
  }

  static async remove(tenantId, dataAreaId) {
    return await del(`/api/tenants/${tenantId}/dataareas/${encodeURIComponent(dataAreaId)}`);
  }

  // Instance methods (use tenantId from constructor)
  async getAll(page = 0, pageSize = 100, filters = {}) {
    const data = await TenantDataAreaService.list(this.tenantId);
    // Map dataAreaId to id for CRUD operations compatibility
    const mappedData = Array.isArray(data) ? data.map(item => ({
      ...item,
      id: item.dataAreaId
    })) : [];
    return { 
      content: mappedData, 
      totalElements: mappedData.length,
      totalPages: 1 
    };
  }

  async create(data) {
    const response = await TenantDataAreaService.add(this.tenantId, data);
    window.dispatchEvent(new CustomEvent("dataAreasUpdated"));
    // Map dataAreaId to id for CRUD operations compatibility
    return {
      ...response,
      id: response.dataAreaId
    };
  }

  async update(id, data) {
    const response = await TenantDataAreaService.update(this.tenantId, id, data);
    window.dispatchEvent(new CustomEvent("dataAreasUpdated"));
    return response;
  }

  async delete(id) {
    const response = await TenantDataAreaService.remove(this.tenantId, id);
    window.dispatchEvent(new CustomEvent("dataAreasUpdated"));
    return response;
  }

  async updateEnabled(id, data) {
    // Not directly supported, use update as fallback
    return await this.update(id, data);
  }

  async getBranding(dataAreaId) {
    return await TenantDataAreaService.getBranding(this.tenantId, dataAreaId);
  }

  async updateBranding(dataAreaId, payload) {
    return await TenantDataAreaService.updateBranding(this.tenantId, dataAreaId, payload);
  }
}

export default TenantDataAreaService;
